import {
  GETWALLETOWNERSETTING_SUCCESS,
  GETWALLETOWNERSETTING_FAILED,
  RESET_GETALLWALLETOWNERSETTING,
  LOADING_GETWALLETOWNERSETTING,
  NETWORK_ERROR_GETWALLETOWNERSETTING,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETWALLETOWNERSETTING:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETWALLETOWNERSETTING_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETWALLETOWNERSETTING_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETWALLETOWNERSETTING:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETALLWALLETOWNERSETTING:
      return (state = initialState);
    default:
      return state;
  }
};
